import { Formik, FormikActions, FormikProps } from 'formik';
import * as React from 'react';
import { connect } from 'react-redux';
import { Redirect, RouteComponentProps } from 'react-router';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import * as Yup from 'yup';
import { Link } from 'react-router-dom';

import { IStore } from 'src/services/store';
import { setLoginError, userLogin } from 'src/services/user/actionCreators';
import { IUserCredentials } from 'src/services/user/types';
import { IWithUserProps, withUser } from 'src/services/withUser';
import LoginForm from './components/LoginForm';

interface ILocationParams {
  user: string;
  pass: string;
}
interface ILoginFunctionProps {
  clearError: () => void;
  logIn: (credentials: IUserCredentials, callback: () => void) => void;
}

interface ILoginProps
  extends ILoginFunctionProps,
    RouteComponentProps<ILocationParams>,
    IWithUserProps {
  loginError: string;
}

class Login extends React.Component<ILoginProps> {
  schema = Yup.object().shape({
    password: Yup.string().required('Required'),
    remember: Yup.bool(),
    username: Yup.string().required('Required'),
  });

  initialValues = {
    username: this.props.match.params.user || '',
    password: this.props.match.params.pass || '',
    remember: false,
  };

  onSubmit = async (
    values: IUserCredentials,
    actions: FormikActions<IUserCredentials>
  ) => {
    const { clearError, logIn } = this.props;
    clearError();
    await logIn(values, () => {
      actions.setSubmitting(false);
    });
  };

  formRender = (props: FormikProps<IUserCredentials>) => {
    return (
      <div className="w-1/2 my-32 mx-auto text-xl">
        <LoginForm loginError={this.props.loginError} {...props} />
        <Link
          to="/password-reset"
          className="inline-block ml-32 mt-6 text-sm text-black border-transparent hover:border-blue border-b-2"
        >
          Forgot password?
        </Link>
      </div>
    );
  };

  render() {
    const { location, user } = this.props;
    const { from } = location.state || { from: { pathname: '/' } };

    if (user.loggedIn) {
      return <Redirect to={from} />;
    }

    return (
      <Formik
        initialValues={this.initialValues}
        validationSchema={this.schema}
        onSubmit={this.onSubmit}
        render={this.formRender}
      />
    );
  }
}

const mapStateToProps = ({ user: { loginError } }: IStore) => ({
  loginError,
});
const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, AnyAction>) => ({
  clearError: () => {
    dispatch(setLoginError(''));
  },
  logIn: (credentials: IUserCredentials, callback: () => void) => {
    dispatch(userLogin(credentials, callback));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(withUser(Login));



// WEBPACK FOOTER //
// ./src/views/Login/Login.tsx